<main class="straordinaria-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">Pulizia straordinaria e post cantiere a Pescara</h1>
            <p class="mb-0 hero-sub">
              Dopo una ristrutturazione o lavori edili, <strong>SAMI Pulizie</strong> si occupa della
              <strong>rimozione di polveri sottili, residui di cemento, vernici, calcare e macchie</strong>.
              Interventi rapidi e mirati per abitazioni, locali commerciali e cantieri.
              <strong>Sopralluogo gratuito</strong> e piano su misura.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi sopralluogo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama 085 54360</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip"><i class="fa-solid fa-broom"></i> Post ristrutturazione</div>
              <div class="chip"><i class="fa-solid fa-spray-can-sparkles"></i> Sgrassaggio &amp; dettagli</div>
              <div class="chip"><i class="fa-solid fa-layer-group"></i> Trattamento pavimenti</div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/pullizia-uffici-pavimenti.webp"
                class="hero-img"
                alt="Pulizia post ristrutturazione e post cantiere a Pescara"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (1) SEZIONE 2 COLONNE -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Cosa facciamo</h2>

          <p class="text-muted mb-3">
            La pulizia post cantiere richiede prodotti e tecniche specifiche per eliminare residui ostinati
            senza rovinare superfici delicate (gres, parquet, marmo, infissi, vetri).
            Interveniamo con attrezzatura professionale e procedure mirate.
          </p>

          <p class="text-muted mb-4">
            Ideale per consegna casa ristrutturata, fine lavori in negozi/uffici e aperture di nuovi locali.
            Il risultato è un ambiente pronto all’uso, pulito in profondità e rifinito nei dettagli.
          </p>

          <ul class="checklist">
            <li><i class="fa-solid fa-check"></i> Rimozione polveri sottili e residui da lavorazioni</li>
            <li><i class="fa-solid fa-check"></i> Eliminazione macchie di vernice, silicone, stucco e colla</li>
            <li><i class="fa-solid fa-check"></i> Rimozione calcare e incrostazioni (bagni e sanitari)</li>
            <li><i class="fa-solid fa-check"></i> Pulizia infissi, vetri e telai (interni/esterni)</li>
            <li><i class="fa-solid fa-check"></i> Trattamento pavimenti e lavaggio profondo</li>
            <li><i class="fa-solid fa-check"></i> Rifiniture finali per consegna “pronto uso”</li>
          </ul>
        </div>

        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Aree di intervento</h3>

            <ul class="bullets">
              <li>Appartamenti e ville post ristrutturazione</li>
              <li>Locali commerciali e negozi (pre-apertura)</li>
              <li>Uffici e studi professionali</li>
              <li>Scale condominiali dopo lavori</li>
              <li>Vetrine, infissi e serramenti</li>
              <li>Bagni, sanitari e zone calcaree</li>
              <li>Garage, cantine e depositi</li>
              <li>Fine cantiere (ambienti completi)</li>
            </ul>

            <div class="note-box mt-3">
              <strong>Nota:</strong> valutiamo sempre materiali e finiture prima di intervenire, per scegliere i prodotti corretti.
            </div>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Vuoi un intervento rapido?</div>
              <div class="mini-cta-text">Sopralluogo gratuito e preventivo chiaro.</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- (2) COME FUNZIONA -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Come funziona</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">Valutiamo residui, superfici e priorità (vetri, pavimenti, bagni).</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Preparazione</div>
              <div class="step-text">Protezione aree sensibili e scelta prodotti/attrezzature adatte.</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Intervento</div>
              <div class="step-text">Rimozione residui + pulizia profonda + lavaggio pavimenti.</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Rifinitura</div>
              <div class="step-text">Dettagli finali e controllo qualità per consegna “pronto uso”.</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- (3) CTA -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">Hai appena finito i lavori?</h2>
      <p class="cta-text">
        Ti aiutiamo a consegnare o utilizzare subito gli ambienti: sopralluogo gratuito e preventivo senza impegno.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi preventivo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="tel:08554360">
          Chiama ora
        </a>
      </div>
    </div>
  </section>

  <!-- MAPPA -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            allowfullscreen
            style="border: 0"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index: 1050">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatta su WhatsApp"
      class="btn btn-success rounded-circle btn-sm"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>
</main>
